var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap page1 f1 df"},[_c('div',{staticClass:"wrap-inner f1 df fdr"},[_c('News')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }